import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Login() {
  const [cpf, setCpf] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(''); // Novo estado para controlar o erro visual
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage(''); // Limpa qualquer erro antigo ao tentar logar novamente

    // Validação de campos vazios
    if (!cpf || !senha) {
      setErrorMessage("Preencha CPF e senha!");
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/auth/login', { cpf_number: cpf, senha });
      const { token, usuario } = response.data;

      // Salvando os dados reais
      localStorage.setItem('token', token);
      localStorage.setItem('usuarioId', String(usuario.id));

      // Vai direto para a Home sem alert()
      navigate('/home');
    } catch (error) {
      console.error("Erro no login:", error);
      // Exibe a mensagem de erro diretamente na tela
      setErrorMessage("Login ou senha estão incorretos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.formBox}>
        <img src="/logo1.png" alt="Logo" style={styles.logo} />
        
        <form onSubmit={handleLogin} style={{ width: '100%' }}>
          <input
            className="input-field"
            type="text"
            placeholder="CPF (somente números)"
            value={cpf}
            onChange={(e) => setCpf(e.target.value.replace(/\D/g, ''))}
            maxLength={11}
          />
          <input
            className="input-field"
            type="password"
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />

          {/* Renderiza a mensagem de erro apenas se ela existir */}
          {errorMessage && (
            <p style={styles.errorText}>{errorMessage}</p>
          )}

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Carregando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(to bottom right, #84c308, #3f8c00)',
    padding: '20px'
  },
  formBox: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    padding: '30px',
    width: '100%',
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
  },
  logo: {
    width: '150px',
    marginBottom: '20px'
  },
  // Novo estilo para a mensagem de erro
  errorText: {
    color: '#dc3545',
    fontSize: '14px',
    textAlign: 'center',
    marginBottom: '15px',
    fontWeight: 'bold',
    margin: '0 0 15px 0'
  }
};